<template>
  <div style="overflow: hidden;">
    <div class="jurisdictionItem">
      <div class="jurisdictionTitle">查看设备</div>
      <newmultipleSelection ref="viewDeviceSelection" :dataList="nowSeviceList" style="height: 320px;"
        :selectionType="selectionType" :getIdMethod="item => item.id"></newmultipleSelection>
    </div>
    <div class="jurisdictionItem">
      <div class="jurisdictionTitle">操作设备</div>
      <newmultipleSelection ref="editDeviceSelection" :dataList="nowSeviceList" style="height: 320px;"
        :selectionType="selectionType" :getIdMethod="item => item.id"></newmultipleSelection>
    </div>
  </div>
</template>

<script>
  import multipleSelection from '@/components/module/selection/base/multipleSelection.vue'
  import newmultipleSelection from '@/components/module/selection/base/newmultipleSelection.vue'
  import userManagerStore from '@/page/userManager/userManagerStore.js'
  export default {
    components: {
      multipleSelection,
      newmultipleSelection
    },
    props: {

    },
    data () {
      return {
        selectionType: 'multiple',
        responData: [],
      }
    },
    created () {},
    mounted () {

    },
    destroyed () {

    },
    computed: {
      user () {
        return userManagerStore.state.nowUser
      },
      unit () {
        return userManagerStore.state.nowUnit
      },
      nowSeviceList () {
        var d=[
          {
            "no": 4,
            "fatherno": 33,
            "pkid": "43",
            "createTime": null,
            "entityName": "AppClassType",
            "name": "智能配电有限公司",
            "unitid": "0A200022945047D7A5E538EDFC40FA2A",
            "id": "43",
            "sort": 1,
            "devicetype": 0,
            "next": [
              {
                "next": [
                  {
                    "no": 24,
                    "pkid": "9c1f372f2f5c4f47a62c7b4a7adf9c9b",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 2,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 4,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "水浸22",
                    "id": "24",
                    "boxId": null
                  },
                  {
                    "no": 11,
                    "pkid": "8583043e9afc486a98e946651c4516c7",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 3,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 934,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "设备机电总进线数显表",
                    "id": "11",
                    "boxId": null
                  },
                  {
                    "no": 13,
                    "pkid": "8785a6448b3b480e978fdfb5bed5bbee",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 4,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 1211,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "水元一4011电线1211",
                    "id": "13",
                    "boxId": null
                  },
                  {
                    "no": 16,
                    "pkid": "3ea8f3d3f19c420db570806a0f77a968",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 5,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 1215,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "气元一4033厂房",
                    "id": "16",
                    "boxId": null
                  },
                  {
                    "no": 19,
                    "pkid": "08fd6f83f6c24eed8b33e393fd8c5f76",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 6,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 23,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "英派尔预付费表",
                    "id": "19",
                    "boxId": null
                  },
                  {
                    "no": 20,
                    "pkid": "ea261b4de661498f887476da9635cd44",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 7,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 6,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "水表",
                    "id": "20",
                    "boxId": null
                  },
                  {
                    "no": 21,
                    "pkid": "f23a720e7e9248fe89b7219031e6009d",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 8,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 9,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "郎瑞杰电表",
                    "id": "21",
                    "boxId": null
                  },
                  {
                    "no": 1,
                    "pkid": "a18fcaaf12514485975e844435536fcb",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 9,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 640,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "益大",
                    "id": "1",
                    "boxId": null
                  },
                  {
                    "no": 3,
                    "pkid": "1bb3f58d1581415e9c4d7b2e6dab81cd",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 10,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 642,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "永兴旺",
                    "id": "3",
                    "boxId": null
                  },
                  {
                    "no": 5,
                    "pkid": "615dbe9966fe499382627980213bd7ac",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 11,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 644,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "利兴强箱变",
                    "id": "5",
                    "boxId": null
                  },
                  {
                    "no": 27,
                    "pkid": "52695891b14148ea8058a223262f7ad0",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 12,
                    "type": "VirtualDevice",
                    "entityno": -1,
                    "deviceaddr": 1,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "t1",
                    "id": "27",
                    "boxId": null
                  },
                  {
                    "no": -31,
                    "pkid": "9e113ab6fa72435fb6ccd4602c8301bf",
                    "parentarea": -1,
                    "channel": 4,
                    "sort": 35,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": -1,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "111",
                    "id": "-31",
                    "boxId": null
                  },
                  {
                    "no": -32,
                    "pkid": "b50e560005fe40d6ba6d10c42e734ec7",
                    "parentarea": -1,
                    "channel": 4,
                    "sort": 36,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": -1,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "222",
                    "id": "-32",
                    "boxId": null
                  },
                  {
                    "no": 67,
                    "pkid": "c8537d9152304c5faab3baeec234587e",
                    "parentarea": 0,
                    "channel": 4,
                    "sort": 51,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": null,
                    "createTime": 1703228787000,
                    "entityName": "VirtualDevice",
                    "name": "金盈毛绒工艺",
                    "id": "67",
                    "boxId": null
                  }
                ],
                "no": 4,
                "fatherno": 3,
                "pkid": "4",
                "createTime": null,
                "entityName": "AppClassType",
                "name": "永宁电气",
                "unitid": "0A200022945047D7A5E538EDFC40FA2A",
                "id": "4",
                "sort": 2,
                "devicetype": 0
              },
              {
                "no": 45,
                "fatherno": 35,
                "pkid": "45",
                "createTime": null,
                "entityName": "AppClassType",
                "name": "电气设备",
                "unitid": "0A200022945047D7A5E538EDFC40FA2A",
                "id": "4",
                "sort": 2,
                "devicetype": 0,
                "next": [
                  {
                    "no": 6,
                    "pkid": "1868c55890bf4d63a177e4f9b8a31b7d",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 10,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 929,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "永宁机电1数显表",
                    "id": "6",
                    "boxId": null
                  },
                  {
                    "no": 7,
                    "pkid": "d3bb0dd4f34a4071852980dfd5ea778d",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 11,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 930,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "永宁机电2数显表",
                    "id": "7",
                    "boxId": null
                  },
                  {
                    "no": 8,
                    "pkid": "d1799f1509b647ec845c0af19afdcd86",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 12,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 931,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "永宁机电3数显表",
                    "id": "8",
                    "boxId": null
                  },
                  {
                    "no": 9,
                    "pkid": "50726393360b491eb27b1a196203cf03",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 13,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 932,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "永宁机电5数显表",
                    "id": "9",
                    "boxId": null
                  },
                  {
                    "no": 12,
                    "pkid": "dca63d9156ed489682619a065ac59f7f",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 14,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 935,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "永宁机电4数显表",
                    "id": "12",
                    "boxId": null
                  },
                  {
                    "no": 14,
                    "pkid": "e3fafcf4f97e43828b04bd6f9f9bdb7d",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 15,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 1213,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "水元一4031厂房",
                    "id": "14",
                    "boxId": null
                  },
                  {
                    "no": 15,
                    "pkid": "062645a268214a2297abf4d4a6ae64ab",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 16,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 1214,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "水元一4032厂房",
                    "id": "15",
                    "boxId": null
                  },
                  {
                    "no": 17,
                    "pkid": "b24c647db6e6433daa99f1d268f48f78",
                    "parentarea": 0,
                    "channel": 5,
                    "sort": 17,
                    "type": "VirtualDevice",
                    "entityno": null,
                    "deviceaddr": 1216,
                    "createTime": null,
                    "entityName": "VirtualDevice",
                    "name": "气元一4034厂房",
                    "id": "17",
                    "boxId": null
                  }]
              }]
          }]
        return d
      },
      // nowViewCheckedIds() {
      // 	return userManagerStore.state.nowUserViewDeviceIds
      // },
      // nowEditCheckedIds() {
      // 	return userManagerStore.state.nowUserEditDeviceIds
      // },
      nowViewCheckedIds: {
        get: function() {
          return userManagerStore.state.nowUserViewDeviceIds
        },
        set: function(newValue) {
          return userManagerStore.state.nowUserViewDeviceIds=newValue
        }
      },
      nowEditCheckedIds: {
        get: function() {
          return userManagerStore.state.nowUserEditDeviceIds
        },
        set: function(newValue) {
          return userManagerStore.state.nowUserEditDeviceIds=newValue
        }
      },
      a () {
        return "调用"
      },
      viewNeedSave () {
        console.log("viewNeedSave变化");
        var viewDevice=[]
        var viewKeys=Object.keys(this.$refs.viewDeviceSelection.nowSelectIds)
        for(let i=0;i<viewKeys.length;i++) {
          if(this.$refs.viewDeviceSelection.nowSelectIds[viewKeys[i]]) {
            viewDevice.push(viewKeys[i])
          }
        }

        if(this.nowViewCheckedIds.length==viewDevice.length) {
          for(let i=0;i<viewDevice.length;i++) {
            if(this.nowViewCheckedIds.indexOf(parseFloat(viewDevice[i]))<0) {
              return true
            }
          }
          return false
        } else {
          return true
        }
      },
      editNeedSave () {
        var editDevice=[]
        var editKeys=Object.keys(this.$refs.editDeviceSelection.nowSelectIds)
        for(let i=0;i<editKeys.length;i++) {
          if(this.$refs.editDeviceSelection.nowSelectIds[editKeys[i]]) {
            editDevice.push(editKeys[i])
          }
        }

        if(this.nowEditCheckedIds.length==editDevice.length) {
          for(let i=0;i<editDevice.length;i++) {
            if(this.nowEditCheckedIds.indexOf(parseFloat(editDevice[i]))<0) {
              return true
            }
          }
          return false
        } else {
          return true
        }
      }
    },
    watch: {
      nowViewCheckedIds () {
        this.resetDatas()
      },
      responData () {
        if(this.responData.length>=2) {
          console.log("侦听器");
          if(this.responData[0].status!=0&&this.responData[1].status!=0) {
            if(this.responData[0].status!=-1&&this.responData[1].status!=-1) {
              this.$dialogMethod.showMessage('设备权限保存成功')
              this.resetCheckedIds()
            } else if(!this.responData[0].status==-1||!this.responData[1].status==-1) {
              this.$dialogMethod.showMessage('设备权限保存失败')
            }
          }
          this.responData=[]
        }
      }
    },
    methods: {
      resetDatas () {
        this.$refs.viewDeviceSelection.setNowCheckedIds(this.nowViewCheckedIds)
        this.$refs.editDeviceSelection.setNowCheckedIds(this.nowEditCheckedIds)
      },
      saveViewDevice () {
        // console.log("viewNeedSave",this.viewNeedSave);
        // if(!this.viewNeedSave){
        // 	this.responData.push({status:0,message:'无需保存'})
        // 	return
        // }
        var viewDeviceArr=[]
        var keys=Object.keys(this.$refs.viewDeviceSelection.nowSelectIds)
        for(let i=0;i<keys.length;i++) {
          if(this.$refs.viewDeviceSelection.nowSelectIds[keys[i]]) {
            viewDeviceArr.push(keys[i])
          }
        }
        this.$api.userApi.bindUserAndDevice('view',this.user.id,viewDeviceArr.join(','),res => {
          this.responData.push({status: 1,message: res})
          this.$dialogMethod.showMessage(res)

        },failure => {
          this.responData.push({status: -1,message: failure})
          this.$dialogMethod.showMessage(failure)
        })
      },
      saveEditDevice () {

        // var editDeviceArr = []
        // var keys = Object.keys(this.$refs.editDeviceSelection.nowSelectIds)
        // for(let i = 0;i < keys.length;i++){
        // 	if(this.$refs.editDeviceSelection.nowSelectIds[keys[i]]){
        // 		editDeviceArr.push(keys[i])
        // 	}
        // }
        var editDeviceStr=this.$refs.editDeviceSelection.checkNodesIdStr
        this.$api.userApi.bindUserAndDevice('edit',this.user.id,editDeviceStr,res => {
          this.responData.push({status: 1,message: res})

          this.$dialogMethod.showMessage(res)
        },failure => {
          this.responData.push({status: -1,message: failure})
          this.$dialogMethod.showMessage(failure)
        })
      },
      saveEdit () {
        this.saveViewDevice()
        this.saveEditDevice()
      },
      resetCheckedIds () {
        if(this.viewNeedSave) {
          var viewDevice=[]
          var viewKeys=Object.keys(this.$refs.viewDeviceSelection.nowSelectIds)
          for(let i=0;i<viewKeys.length;i++) {
            if(this.$refs.viewDeviceSelection.nowSelectIds[viewKeys[i]]) {
              viewDevice.push(viewKeys[i])
            }
          }
          this.nowViewCheckedIds=viewDevice
        }

        if(this.editNeedSave) {
          var editDevice=[]
          var editKeys=Object.keys(this.$refs.editDeviceSelection.nowSelectIds)
          for(let i=0;i<editKeys.length;i++) {
            if(this.$refs.editDeviceSelection.nowSelectIds[editKeys[i]]) {
              editDevice.push(editKeys[i])
            }
          }
          this.nowEditCheckedIds=editDevice
        }
      }
    }
  }
</script>

<style>
  .jurisdictionItem {
    border: solid 1px #E4E4E4;
    box-sizing: border-box;
    float: left;
    margin-right: 30px;
    width: calc(50% - 15px);
  }

  .jurisdictionItem:last-child {
    margin-right: 0;
  }

  .jurisdictionItem .list-body {
    border: none;
  }

  /* .jurisdictionTitle{
		font-size: 14px;
		color: #666666;
		line-height: 20px;
		background: #E3E7EC;
		text-align: center;
		line-height: 30px;
	} */
</style>